.atm_9s_1txwivl{display:flex;}
.atm_mk_h2mmj6{position:relative;}
.atm_1gkhzp4_1yyfdc7:before{content:'';}
.atm_a5qyg8_1osqo2v:before{height:100%;}
.atm_43j8m0_idpfg4.atm_43j8m0_idpfg4:before{flex-shrink:0;}
.atm_x4yteh_stnw88:before{position:absolute;}
.atm_tb79i2_idpfg4:before{top:0;}
.atm_1xce73l_idpfg4:before{left:0;}
.atm_j6_1tcgj5g{min-height:24px;}
.atm_j3_kbqlyw{max-width:450px;}
.atm_12jvgb5_1y44olf:before{width:4px;}
.atm_1tg13kq_1v14isf:before{border-radius:4px 0 0 4px;}
.atm_j6_1ylpe5n{min-height:40px;}
.atm_j3_cv9350{max-width:700px;}
.atm_12jvgb5_i2wt44:before{width:6px;}
.atm_1tg13kq_1mnk5sk:before{border-radius:8px 0 0 8px;}
.atm_j6_t9kd1m{min-height:72px;}
.atm_12jvgb5_ftgil2:before{width:8px;}
.atm_lv2p12_1ngez80.atm_lv2p12_1ngez80:before{background-color:#FFC700;}
.atm_lv2p12_1amel2c.atm_lv2p12_1amel2c:before{background-color:#08873F;}
.atm_lv2p12_9ztun4.atm_lv2p12_9ztun4:before{background-color:#DD3131;}
.atm_lv2p12_1aemfod.atm_lv2p12_1aemfod:before{background-color:#146EF5;}
.atm_lv2p12_1kfv0pa.atm_lv2p12_1kfv0pa:before{background-color:#018479;}
.atm_7l_1hutuam{color:#202328;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_vy_1ns9ob4{width:fit-content;}
.atm_j3_1osqo2v{max-width:100%;}
.atm_i2dn9l_idpfg4.atm_i2dn9l_idpfg4 >:first-child{flex-shrink:0;}
.atm_l8_1y44olf{padding:4px;}
.atm_lk_ohfyis.atm_lk_ohfyis{padding-left:calc(4px + 4px);}
.atm_cx_1y44olf{gap:4px;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_3f_glywfm{border:none;}
.atm_l8_ftgil2{padding:8px;}
.atm_lk_16sivcx.atm_lk_16sivcx{padding-left:calc(8px + 6px);}
.atm_cx_ftgil2{gap:8px;}
.atm_5j_ftgil2{border-radius:8px;}
.atm_l8_exct8b{padding:16px;}
.atm_lk_p76gy6.atm_lk_p76gy6{padding-left:calc(16px + 8px);}
.atm_cx_exct8b{gap:16px;}
.atm_2d_kynrkz.atm_2d_kynrkz{background-color:#FFF1D6;}
.atm_3f_6fznzl{border:1px solid #FFC700;}
.atm_2d_1g58d4e.atm_2d_1g58d4e{background-color:#E5FBEE;}
.atm_3f_1ycbfbi{border:1px solid #08873F;}
.atm_2d_cribmc.atm_2d_cribmc{background-color:#FFF1F0;}
.atm_3f_148wyss{border:1px solid #DD3131;}
.atm_2d_1rmaw06.atm_2d_1rmaw06{background-color:#EBF3FF;}
.atm_3f_5ltqcd{border:1px solid #146EF5;}
.atm_2d_96vfts.atm_2d_96vfts{background-color:#0184791a;}
.atm_3f_1xnhkb5{border:1px solid #018479;}
